<template>
	<div class="stocklist">
		<el-card>
			<div v-for="tab in tabs">
				<el-row>
					<el-col :span="24">
						<el-form :inline="true" label-width="90px" size="mini">
							<el-form-item label="商品编号">
								<el-input v-model="searchlist.cno" type="text" style="width:120px">
								</el-input>
							</el-form-item>
							<el-form-item label="所在仓库">
								<el-select
									v-model="searchlist.storehouse"
									size="mini"
									:clearable="true"
									:filterable="true"
									style="width:150px"
								>
									<el-option v-for="item in storehouselist" :key="item.title" :label="item.title" :value="item.title"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="操作时间">
								<el-date-picker
								      v-model="searchlist.starttime"
								      type="date"
									  placeholder="开始日期" style="width:130px"
									  value-format="yyyy-MM-dd">
								    </el-date-picker>
								<!-- <el-date-picker
								      v-model="searchlist.time"
								      type="daterange"
								      align="right"
								      unlink-panels
								      range-separator="至"
								      start-placeholder="开始日期"
								      end-placeholder="结束日期"
									  value-format="yyyy-MM-dd"
								      :picker-options="pickerOptions">
								    </el-date-picker> -->
							</el-form-item>
							<el-form-item>
								<el-date-picker
								      v-model="searchlist.endtime"
								      type="date"
									  placeholder="结束日期" style="width:130px"
									  value-format="yyyy-MM-dd">
								    </el-date-picker>
								<!-- <el-date-picker
								      v-model="searchlist.time"
								      type="daterange"
								      align="right"
								      unlink-panels
								      range-separator="至"
								      start-placeholder="开始日期"
								      end-placeholder="结束日期"
									  value-format="yyyy-MM-dd"
								      :picker-options="pickerOptions">
								    </el-date-picker> -->
							</el-form-item>
							<el-form-item label="操作类型">
								<el-select
									v-model="searchlist.handletype"
									size="mini"
									style="width:100px"
								>
									<el-option v-for="item in handletypelist" :key="item.title" :label="item.title" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button size="mini" type="success" @click="refreshgrid(true)">查询</el-button>
								<el-button size="mini" @click.native="ResetFilterInfo()" type="warning">重置</el-button>
							</el-form-item>
							<el-form-item>
								<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
					<el-col :span="24">
						<tableui
							style="width:100%;"
							v-loading="loading"
							ref="stocklist"
							editcell="0"
							:tableData="orderlist"
							:columns="tab.columns"
							:gridheight="gridheight"
							@gridsort="gridsort"
							@cellclick="cellclick"
							@checkboxchange="checkboxchange"
							@gridscroll="gridscroll"
						></tableui>
					</el-col>
				</el-row>
			</div>
			<div>
				<el-row>
					<el-col :span="12">
						<span>共 {{count}} 条数据</span>
				    </el-col>
					<el-col :span="12">
						<div style="text-align:right;">
							<b>汇总 </b>
							<span style="margin-left: 10px;">入库：{{sum.innum}} </span>
							<span style="margin-left: 10px;">出库：{{sum.outnum}}</span>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>
		<exportwin ref="exportwin"></exportwin>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
import exportwin from '@/components/order/exportwin.vue';
export default {
	components: {
		tableui,
		handlerbutton,
		exportwin
	},
	data() {
		return {
			searchlist: {
				id:'',
				storehouse:'',
				cno:'',
				starttime:'',
				endtime:'',
				handletype:''
			},
			handletypelist:[{value:'',title:'全部'},{value:'1',title:'入库'},{value:'0',title:'出库'},{value:'2',title:'报溢'},{value:'3',title:'报损'},{value:'4',title:'盘盈'},{value:'5',title:'盘亏'}],
			activeTabIndex: 0, //激活的选项卡index
			activeName:'',
			pickerOptions: {
			  shortcuts: [{
				text: '最近一周',
				onClick(picker) {
				  const end = new Date();
				  const start = new Date();
				  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				  picker.$emit('pick', [start, end]);
				}
			  }, {
				text: '最近一个月',
				onClick(picker) {
				  const end = new Date();
				  const start = new Date();
				  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				  picker.$emit('pick', [start, end]);
				}
			  }, {
				text: '最近三个月',
				onClick(picker) {
				  const end = new Date();
				  const start = new Date();
				  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				  picker.$emit('pick', [start, end]);
				}
			  }]
			},
			orderlist: [],
			gridheight: (window.innerHeight * 70) / 100 + 'px',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '商品报表', //当前操作的功能模块名称
			selectedall: false,
			checkedrow: [],
			count:0,
			customerlist:[],
			divclass:'stocklist',
			storehouselist:[],
			sum:{
				innum:0,
				outnum:0
			}
		}; 
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/stockmanager/stocklist.scss');
			this.getTabs();
		});
	},
	methods: {
		getstorehouselist(){
			var that = this;
			this.$apipost.get.GetDicByRole({type:'仓库'}).then(res => {
				if(res.list!=undefined)
					that.storehouselist=res.list;
			});
		},
		//获取选项卡
		getTabs() {
			this.$apipost.get.GetTabs({ parentid: 410 }).then(res => {
				this.tabs = res.tabs;
				this.activeName=res.tabs[0].type;
				this.GetTabData();
				this.getstorehouselist();
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				id:'',
				storehouse:'',
				cno:'',
				starttime:'',
				endtime:'',
				handletype:''
			};
		},
		//获取表头方法
		GetTabData() {
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if(e!=undefined){
				var that = this;
				const scrollDistance = e.event.target.scrollHeight -e.e.scrollTop-e.event.target.offsetHeight;
				if (scrollDistance <=90) {
					that.refreshgrid(false);
				}
			}
		},
		buttonhandle(e) {
			if (e.event == 'export') {
				this.ExportList();
			}
		},
		cellclick(e){
			if(e.event=='openurl')
			{
				if(e.column.field=='billid'){
					Utils.$emit('handleRermove','单据详情');
					var value=e.row[e.column.field];
					var type=e.row.type;
					var handletype=e.row.handletype;
					var l_id=e.row.l_id;
					setTimeout(function(){
						Utils.$emit('go', { l_url: '/stockmanager/createstockinfo', l_id:l_id, l_name:'单据详情',urlparam: {pkval:value,iscopy:0, l_tablename:type,handletype:handletype,isdetail:1 }});
					},200); 
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.orderlist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				var paraminfo={
					search: this.GetSearchObj(),
					tab:this.tabs[this.activeTabIndex].type,
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					l_mode:this.mode,
					userid:localStorage.getItem('userid')
				}
				// console.log('入库列表',escape(JSON.stringify(paraminfo)));
				// return false;
				this.loading = true;
				this.$apipost.get
					.GetStockCargoReport({
						paraminfo:paraminfo
					})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.orderlist=that.orderlist.concat(res.data);
							} else {
								that.orderlist = res.data;
							}
							this.count=res.count;
							that.tabs[this.activeTabIndex].pagecount = res.pagecount;
						}
						that.GetCargosum();
					}).catch(e=>{
						that.refreshgrid(isrefresh);
					});
			}
		},
		GetCargosum(){
			var that=this;
			that.sum={
				innum:0,
				outnum:0
			}
			var paraminfo={
				search: this.GetSearchObj(),
				tab:this.tabs[this.activeTabIndex].type,
				l_mode:this.mode,
				userid:localStorage.getItem('userid')
			}
			this.$apipost.get
				.GetStockCargoInOutList_SumCount({
					paraminfo:paraminfo
				})
				.then(res => {
					if(res.state==1){
						that.sum=res;
					}
				}).catch(e=>{
					that.GetCargosum();
				});
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if(search.starttime==null)
				search.starttime='';
			if(search.endtime==null)
				search.endtime='';
			return JSON.stringify(search);
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式 
			//console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//重置筛选
		ResetFilterInfo(){
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				id: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					pkval += e.id + ',';
				});
				if (pkval != '') {
					pkval = pkval.substring(0, pkval.length - 1);
					search.id = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选数据', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//导出
		ExportList() {
			var that = this;
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				if (that.$refs.exportwin != undefined) {
					that.$refs.exportwin.init({
						searchinfo: searchinfo,
						pageparam: that._data,
						handtype: 7
					});
				}
			}
		}
	}
};
</script>
